const ALL_REQUESTS = 'ALL_REQUESTS'
const REFERRED_REQUESTS_ONLY = 'REFERRED_REQUESTS_ONLY'
const NONE = 'NONE'

// admin permission names
const MASTER = 'MASTER'
const UPLOAD_ONLY = 'UPLOAD_ONLY'
const DECISION_REFERRAL = 'DECISION_REFERRAL'
const READ_ONLY = 'READ_ONLY'
const TCR_ADMIN = 'TCR_ADMIN'
const SHEF_UPLOAD_ONLY = 'SEHF_UPLOAD_ONLY'
const NORTHWESTERN = 'NORTHWESTERN'

const REFERRED_REQUESTS_ALLOWED_PERMISSIONS = [ALL_REQUESTS, REFERRED_REQUESTS_ONLY]

export const permissionNames = {
  MASTER,
  UPLOAD_ONLY,
  DECISION_REFERRAL,
  READ_ONLY,
  TCR_ADMIN,
  SHEF_UPLOAD_ONLY,
  NORTHWESTERN,
}

export default {
  ALL_REQUESTS,
  REFERRED_REQUESTS_ONLY,
  NONE,
  REFERRED_REQUESTS_ALLOWED_PERMISSIONS,
}
